﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { TaskType } from '../../models/DmaTasks/task-type';
import SortableList from '../../components/Common/SortableList';
import { LookupItem } from '../../models/lookup-item';
import { SortableListData } from '../../models/Common/sortable-list-data';

import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';

export interface Props {
    onSubmit: (taskName: string, data: SortableListData) => void;
    onCancel: () => void;
}

export default function TaskBuilderComponent(props: Props) {
    const [lists, setLists] =
        useState<SortableListData[]>([]);

    const [newTaskName, setNewTaskName] =
        useState<string>();

    const [taskTypes, setTaskTypes] =
        useState<TaskType[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        assembleListData();
    }, [taskTypes]);

    return (
        <div className="sortable-list-full-screen-dialog">
            <div className="pw-comp-row pw-margin-top-05">
                <div className="pw-form-unit pw-comp-15">
                    <div className="pw-form-unit-label">Task Name</div>
                    <TextBox id="newTaskName" className="textbox"
                        onValueChanged={onNewTaskValueChanged}
                        showClearButton={true}
                        placeholder="NA"
                        value={newTaskName ? newTaskName : undefined} />
                </div>
            </div>

            <div className="white-space-no-wrap" style={{ height: "100%" }} >
                <SortableList
                    title="New Task" data={lists && lists[0] && lists[0].data}
                    id="0" key="list0" useCheckBox={false} showIndex={true}
                    onCardDrop={onCardDrop}
                    onCardReorder={onCardReorder} />
                <SortableList
                    title="Available Tasks" data={lists && lists[1] && lists[1].data}
                    id="1" key="list1" useCheckBox={false}
                    onCardDrop={onCardDrop}
                    onCardReorder={onCardReorder} />
            </div>

            <div className="pw-comp-row pw-margin-top-2">
                <div className="pw-centered-buttons-container">
                    <Button id="saveButton"
                        className="pw-button"
                        text="Save" type="success"
                        hint="save definition"
                        height="2.1rem"
                        onClick={onSaveTaskDefinitionClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height="2.1rem"
                        onClick={onCancelTaskDefinitionClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onSaveTaskDefinitionClick() {

        //TODO: need some kind of validation before shutting the dialog

        if (props.onSubmit)
            props.onSubmit(newTaskName, lists[0]);
    }

    function onCancelTaskDefinitionClick() {
        if (props.onCancel)
            props.onCancel();
    }

    function onNewTaskValueChanged(e: any) {
        setNewTaskName(e.value);
    }

    function onCardDrop(e: any) {
        console.log("onCardDrop (AT PARENT)");
        console.log(e);

        if (e.element && lists && lists.length === 2) {
            //drop from Available Tests list
            if (e.element.id && e.element.id === "list0") {
                let editedLists = [...lists];

                editedLists[0].data.splice(e.toIndex, 0, e.fromData[e.fromIndex])
                //editedLists[1].data.splice(e.fromIndex, 1);

                setLists(editedLists);

            }
            else if (e.element.id && e.element.id === "list1") {
                let editedLists = [...lists];

                editedLists[1].data.splice(e.toIndex, 0, e.fromData[e.fromIndex])
                editedLists[0].data.splice(e.fromIndex, 1);

                setLists(editedLists);
            }
        }
    }

    function onCardReorder(e: any) {
        console.log("onCardReorder (AT PARENT)");
        console.log(e);

        if (e.element && lists && lists.length === 2) {
            //reordering only allowed on New Test Spec list
            if (e.element.id && e.element.id === "list0") {
                let editedLists = [...lists];

                const item = editedLists[0].data.splice(e.fromIndex, 1);

                console.log("spliced out item:");
                console.log(item);

                editedLists[0].data.splice(e.toIndex, 0, item[0]);

                setLists(editedLists);
            }
        }
    }

    async function getTaskTypes() {
        await CrudFunctions.getData("dmatasks/tasktypes")
            .then((data) => {
                //console.log("taskTypes:");
                //console.log(data);

                setTaskTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Task Types");
            });
    }

    async function getAllData() {
        await getTaskTypes();
    }

    function assembleListData() {
        if (!taskTypes)
            return;

        let newLists: SortableListData[] = [];

        let taskTypesListData = taskTypes.map(function (tt) { return { id: tt.taskTypeId, subject: tt.name, content: 'description...' }; });

        newLists.push({ title: "New Task", data: [] });
        newLists.push({ title: "Available Tasks", data: taskTypesListData });

        console.log("lists:");
        console.log(newLists);

        setLists(newLists);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}


